import React, { useState } from 'react';
import { useBoardState, useBoardActions } from '../context/BoardContext';
import { useToggle } from 'hooks/useToggle';
import LeadActionsContext from '../context/LeadActionsContext';
import Header from './Header';
import KanbanBoard from './KanbanBoard';
import OperationStatusIndicator from './OperationStatusIndicator';
import LeadSettings from './LeadSettings/LeadSettings';
import { ConvertCaseDialogue } from 'modules/lead/LeadDetails/components/Overview/components/ConvertCaseDialog/ConvertCaseDialog';
import CloseLeadDialog from 'modules/lead/LeadDetails/components/Overview/components/CloseLeadDialog/CloseLeadDialog';
import { useLeadDetails } from 'modules/lead/hooks/useLeadDetails';

const BoardContent = () => {
  const { operationStatus } = useBoardState();
  const { removeLead, moveLeadToClosedStage } = useBoardActions();
  const [showLeadSettings, setShowLeadSettings] = useState(false);
  const [convertCaseToggle, setConvertCaseToggle] = useToggle();
  const [closeCaseToggle, setCloseCaseToggle] = useToggle();

  const { leadDetails, loadLeadDetails, clearData } = useLeadDetails();

  // Handler to open Convert to Case dialog
  const handleOpenConvertCase = (leadDetails) => {
    loadLeadDetails(leadDetails.sk);
    setConvertCaseToggle(true);
  };

  // Handler to open Close Lead dialog
  const handleOpenCloseLead = (leadDetails) => {
    loadLeadDetails(leadDetails.sk);
    setCloseCaseToggle(true);
  };

  // Handler when Convert Case dialog is closed
  const onHideConvertCase = (action) => {
    setConvertCaseToggle(false);

    // If converted, remove lead from the board
    if (action === 'converted' && leadDetails) {
      removeLead(leadDetails.sk, leadDetails.lead_stage);
    }

    clearData();
  };

  // Handler when Close Lead dialog is closed
  const onHideCloseCase = (event) => {
    setCloseCaseToggle(false);

    // If closed, move lead to closed stage
    if (event === 'closed' && leadDetails) {
      moveLeadToClosedStage(leadDetails.sk, leadDetails.lead_stage);
    }

    clearData();
  };

  // Context value with lead action handlers
  const leadActionsValue = {
    openConvertCase: handleOpenConvertCase,
    openCloseLead: handleOpenCloseLead,
  };

  return (
    <LeadActionsContext.Provider value={leadActionsValue}>
      <div className="jira-board-app">
        <Header setShowLeadSettings={setShowLeadSettings} />
        <KanbanBoard />
        <OperationStatusIndicator operationStatus={operationStatus} />
        {showLeadSettings && <LeadSettings visible={showLeadSettings} onHide={() => setShowLeadSettings(false)} />}
        {convertCaseToggle && leadDetails && <ConvertCaseDialogue onHide={onHideConvertCase} leadDetails={leadDetails} />}
        {closeCaseToggle && leadDetails && <CloseLeadDialog onHide={onHideCloseCase} leadDetails={leadDetails} />}
      </div>
    </LeadActionsContext.Provider>
  );
};

export default React.memo(BoardContent);
